import Swal from "sweetalert2";

class HandleSession {
  constructor() {
    this.setSessionTimeout();
    $(document).ajaxStart(() => this.resetSessionTimeout());
    document.addEventListener("turbolinks:click", () => this.resetSessionTimeout());
  }

  setSessionTimeout() {
    this.timeoutID = setTimeout(() => {
      $.ajax({
        url: window.location.href,
        error: () => this.showSessionExpiredPopup()
      })
        .fail(() => this.showSessionExpiredPopup() )
        .done(() => this.resetSessionTimeout() );
    }, 1800001) // 30 minutes and 1 milliseconds
  }

  resetSessionTimeout() {
    window.clearTimeout(this.timeoutID);
    this.setSessionTimeout();
  }

  showSessionExpiredPopup() {
    Swal.fire({
      title: 'Sessão Expirada',
      html: `
        <div class="d-flex justify-content-center mb-4"><svg style="width: 250px; height: 100px;" id="Layer_1" enable-background="new 0 0 512.086 512.086" height="512" viewBox="0 0 512.086 512.086" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m278.741 278.741-40.86 40.86-45.396-45.396 40.86-40.86-21.213-21.213-40.86 40.86-31.271-31.271-77.617 77.616c-36.291 36.291-37.314 94.688-3.087 132.237l-59.297 59.299 21.213 21.213 59.292-59.292c17.678 16.132 40.41 24.967 64.5 24.967 25.59 0 49.648-9.965 67.743-28.06l77.616-77.617-31.271-31.271 40.86-40.86zm-87.206 149.747c-12.429 12.428-28.953 19.273-46.53 19.273s-34.101-6.845-46.53-19.273l-14.877-14.878c-25.656-25.657-25.656-67.403 0-93.06l56.404-56.403 107.936 107.936z"/><path d="m512.086 21.213-21.213-21.213-59.292 59.292c-17.678-16.132-40.41-24.967-64.5-24.967-25.59 0-49.648 9.965-67.743 28.06l-77.616 77.617 150.362 150.362 77.617-77.616c36.291-36.291 37.314-94.689 3.087-132.237zm-83.598 170.322-56.404 56.403-107.936-107.936 56.403-56.404c12.429-12.428 28.953-19.273 46.53-19.273s34.101 6.845 46.53 19.273l14.877 14.877c25.656 25.657 25.656 67.403 0 93.06z"/></g></svg></div>
        Sua sessão expirou. Conecte-se novamente para continuar usando o sistema!
      `,
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
      type: 'warning',
      showCancelButton: false,
      keydownListenerCapture: true,
      confirmButtonText: 'Fazer Login',
      onClose: (result) => {
        window.location.reload();
      }
    })
  }
}

$(() => new HandleSession());